/**
 * @file border.ts
 *
 * @fileoverview Borders utility methods for generating classes and types for components that need to use
 * dynamic responsive borders like border width or style.
 */

import { jobiqoCSSModuleClasses } from "../types/cssModules";
import { getClasses } from "../utils/responsive";

export type BorderStyleType =
  | "none"
  | "hidden"
  | "dotted"
  | "dashed"
  | "solid"
  | "double"
  | "groove"
  | "ridge"
  | "inset"
  | "outset";

export type BorderProps = {
  borderTopColor?: string | string[];
  borderTopWidth?: number | string;
  borderTopStyle?: BorderStyleType;
  borderBottomColor?: string | string[];
  borderBottomWidth?: number | string;
  borderBottomStyle?: BorderStyleType;
  borderRightColor?: string | string[];
  borderRightWidth?: number | string;
  borderRightStyle?: BorderStyleType;
  borderLeftColor?: string | string[];
  borderLeftWidth?: number | string;
  borderLeftStyle?: BorderStyleType;
  borderColor?: string | string[];
  borderWidth?: number | string;
  borderStyle?: BorderStyleType;
};

export const generateBorderClasses = (
  {
    borderTopColor,
    borderBottomColor,
    borderLeftColor,
    borderRightColor,
    borderColor,
  }: BorderProps,
  styles: jobiqoCSSModuleClasses | null = null
): string => {
  return `
    ${getClasses(styles, "brdtc", borderTopColor)}
    ${getClasses(styles, "brdbc", borderBottomColor)}
    ${getClasses(styles, "brdlc", borderLeftColor)}
    ${getClasses(styles, "brdrc", borderRightColor)}
    ${getClasses(styles, "brdc", borderColor)}
  `.trim();
};
